import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-back-button",
  templateUrl: "./back-button.component.html",
  styleUrls: ["./back-button.component.scss"],
})
export class BackButtonComponent {
  @Input() backLabel?: string; // optional

  constructor(private router: Router, private location: Location) {}

  goToPreviewPage() {
    console.log("Back label:", this.backLabel);
    if (this.backLabel) {
      switch (this.backLabel.toLowerCase()) {
        case "role management":
          this.router.navigate(["/role-management/role-list"]);
          break;

        case "mail management":
          this.router.navigate(["/custom-mail/custom-mail"]);
          break;

        case "product":
          this.router.navigate(["/product/product-List"]);
          break;
        case "attribute":
          this.router.navigate(["/attribute/attribute-list"]);
          break;
        case "store management":
          this.router.navigate(["/store/store-list"]);
          break;
        case "staff member":
          this.router.navigate(["/staff-member/staff-member-list"]);
          break;
        case "category management":
          this.router.navigate(["/category/category-list"]);
          break;
        case "recurring purchase":
          this.router.navigate(["/recurring-purchases/recurring-purchase-list"]);
          break;
        case "sub-admin":
          this.router.navigate(["/subadmin/subadmin-list"]);
          break;
        case "add payment method":
          this.router.navigate(["/payment-methods/savecards"]);
          break;
        case "subscription plan":
          this.router.navigate(["/subscription/active"]);
          break;
        default:
          this.location.back();
      }
    } else {
      this.location.back();
    }
  }
}
